const endpoint = {
  // MOBILE APP VERSION (public)
  APP_VERSION: '/app-version',

  // BUSINESS PLANS (public - landing page)
  BUSINESS_PLANS: '/business-plans',

  // LOGIN ENDPOINT
  LOGIN: `login`,

  // LOGOUT ENDPOINT
  LOGOUT: "logout",

  // USERS / STAFF / AGENTS ENDPOINT
  USERS: '/users',

  // REGISTER ENDPOINT
  REGISTER: `register`,

  // FORGOT PASSWORD ENDPOINTS
  FORGOT_PASSWORD: '/forgot-password',
  RESEND_OTP: '/resend-otp',
  RESET_PASSWORD: '/reset-password',

  //TEMPLATES ENDPOINTS
  TEMPLATESTORE: `/template`,

  // TEMPLATE ACTIVE ENDPOINT
  TEMPLATE_ACTIVE:'/template/active',

  // LANGUAGE ENDPOINT
  LANGUAGES: `/languages`,

  // GROUP ENDPOINT
  GROUP: `/groups`,

  // META EMBEDDED SIGNUP
  META_EMBEDDED_SIGNUP: '/meta/embedded-signup',

  // WHATSAPP ACCOUNT ENDPOINT
  WHATSAPP_ACCOUNTS: "/whatsapp-accounts",

  // CAMPAIGN ENDPOINT
  CAMPAIGNS: "/campaigns",

  // MESSAGE ACCOUNTS
  MESSAGE_ACCOUNTS: "/messages/account",

  // MESSAGE CHAT
  MESSAGE_CHAT: "/messages/chat",

  // MESSAGE
  MESSAGE: "/messages",

  // CHANGE PASSWORD ENDPOINT
  CHANGE_PASSWORD: "/changepassword",

  // DELETE ACCOUNT ENDPOINT
  DELETE_ACCOUNT: "/delete-account",

  // DASHBOARD ENDPOINT
  DASHBOARD:'/dashboard',

  // COUNTRIES ENDPOINT
  COUNTRIES:'/countries',

   // RECIPIENT ENDPOINT
  RECIPIENT:'/recipient',
  FOLLOWUPS: '/recipient/followups',

  // RECIPIENT IMPORT
  RECIPIENT_IMPORT:'/recipient/import',

  // INDIVIDUAL MSG
  INDIVIDUAL_MSG:'/messages/sendIndividualMsg',

  // PROFILE ENDPOINT
  PROFILE: '/profile',

  // PLANS ENDPOINT
  PLANS: '/plans',

  // SUBSCRIPTIONS ENDPOINT
  SUBSCRIPTIONS: '/subscriptions',

  // PAYMENTS ENDPOINT (read-only history)
  PAYMENTS: '/payments',

  // QUOTA ENDPOINT
  QUOTA: '/quota',

  // BILLING ENDPOINT (razorpay)
  BILLING: '/billing',

  // AUTO REPLIES ENDPOINT
  AUTO_REPLIES: '/auto-replies',

  // API KEYS ENDPOINT
  API_KEYS: '/api-keys',

  // CLIENT WEBHOOKS ENDPOINT
  CLIENT_WEBHOOKS: '/client-webhooks',

  // INBOX ENDPOINT (backed by ConversationController's /conversations routes)
  INBOX: '/conversations',

  // QUICK REPLIES ENDPOINT
  QUICK_REPLIES: '/quick-replies',

  // ACTIVITY LOG ENDPOINT
  ACTIVITY_LOG: '/activity-log',

  // SESSIONS ENDPOINT (active Sanctum tokens for the current user)
  SESSIONS: '/sessions',

  // SUPPORT ENDPOINTS
  SUPPORT_PUBLIC_QUERY: '/support/public-query',
  SUPPORT_TICKETS: '/support/tickets',

  // image url for preview
  // Deliberately not a hardcoded prod domain: fall back to the origin of the
  // configured API URL so a misconfigured build fails loudly in dev instead
  // of silently talking to production.
  url:
    process.env.REACT_APP_ASSET_URL ||
    (process.env.REACT_APP_API_URL || "http://localhost:8000/api").replace(/\/api\/?$/, ""),
};


export default endpoint;
